import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const THIColoredIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0  331.7 338.58" style={{ color, fontSize, ...style }} {...rest}>
      <path
        style={{ fill: '#A3D2EB' }}
        d="M131.56,328.57c-7.36-0.98-13.94-4.1-20.12-7.94c-18.3-11.35-29.8-27.65-33.29-48.93
	c-3.37-20.56,1.53-39.29,14.58-55.73c3.16-3.99,6.61-7.69,10.72-10.7c1.68-1.23,1.68-2.91,1.68-4.72
	c-0.02-34.54-0.02-69.07-0.02-103.61c0-15.23-0.07-30.45,0.02-45.68c0.06-9.74,1.94-19.03,7.73-27.17c4.48-6.3,9.88-11.5,17.3-14.24
	c1.26-0.62,2.36-0.06,3.41,0.53c8.62,4.83,14.85,11.84,18.75,20.89c0.61,1.42,1.6,3.24-1.1,3.86c-2.2,0.03-4.4-0.21-6.57,0.43
	c-4.7,1.38-7.82,4.38-9.23,9.07c-0.8,2.66-0.91,5.41-0.91,8.18c-0.02,21.81,0.09,43.62-0.04,65.43
	c-0.01,32.54-0.01,65.08,0.03,97.61c0,3-0.55,5.17-3.7,6.56c-15.9,7.01-26.19,23.67-24.03,42.83c1.79,15.86,13.77,31.53,32.45,35.43
	c10.89,2.52,20.97,0.32,30.47-5.26c1.21-0.71,2.27-1.81,3.87-1.63c1.91,2,0,3.51-0.88,4.88c-4.99,7.78-11.34,14.31-18.81,19.74
	c-5.11,3.72-10.72,6.52-16.62,8.76C135.43,327.88,133.57,328.54,131.56,328.57z"
      />
      <path
        style={{ fill: '#B8DAF0' }}
        d="M152.07,34.44c-0.05-4.43-2.86-7.6-5.14-10.96c-4.2-6.2-9.73-10.86-16.76-13.62c8.91-4.77,18.38-5.07,27.9-2.85
	c17.44,4.07,29.64,18.45,31.9,36.63c0.38,3.09,0.51,6.14,0.51,9.21c0.01,49.02,0.03,98.04-0.03,147.06c0,2.61,0.69,4.27,2.81,6.11
	c13.55,11.74,22.07,26.34,24.49,44.34c2.67,19.83-2.13,37.72-14.3,53.36c-11.56,14.86-26.98,23.67-45.78,26.21
	c-8.78,1.19-17.53,1.28-26.12-1.36c4.14-2.03,8.61-3.22,12.75-5.31c11.6-5.86,20.66-14.47,27.88-25.14
	c0.85-1.25,1.76-2.57,1.69-4.23c0.28-2.34,2.26-3.45,3.71-4.87c8.06-7.85,11.8-17.72,11.89-28.58c0.1-11.91-4.41-22.38-13.25-30.71
	c-0.88-0.82-1.99-1.42-2.5-2.6c-2.17-5.6-6.02-10.05-9.87-14.5c-1.06-1.23-2.4-2.26-2.67-4.02c-0.21-1.21-0.21-2.43-0.21-3.64
	c-0.01-27.82,0-55.64,0-83.46c0-0.66-0.01-1.33,0.09-1.98c-0.09-22.47-0.15-44.94,0.04-67.41c0.06-6.95-1.53-12.62-8-16.12
	C152.52,35.69,152,35.23,152.07,34.44z"
      />
      <path
        style={{ fill: '#435C73' }}
        d="M254.2,139.9c6.51,0,13.03-0.03,19.54,0.01c5.25,0.03,8.42,2.84,8.35,7.29c-0.07,4.28-3.21,6.99-8.3,7.01
	c-13.25,0.03-26.5,0.04-39.75,0c-5.26-0.01-8.47-2.87-8.39-7.29c0.08-4.26,3.25-6.97,8.34-7C240.73,139.86,247.46,139.9,254.2,139.9
	z"
      />
      <path
        style={{ fill: '#435C73' }}
        d="M253.69,83.45c-6.73,0-13.47,0.03-20.2-0.01c-4.69-0.03-7.86-2.95-7.84-7.1c0.02-4.11,2.97-6.94,7.6-6.96
	c13.8-0.06,27.59-0.07,41.39,0c4.64,0.02,7.48,2.86,7.46,7.05c-0.02,4.14-2.99,6.97-7.55,7.01
	C267.6,83.49,260.64,83.45,253.69,83.45z"
      />
      <path
        style={{ fill: '#435C73' }}
        d="M246.78,48.2c-4.41,0-8.83,0.07-13.24-0.02c-4.78-0.09-7.87-2.94-7.89-7.11c-0.02-4.17,3.07-7.12,7.83-7.16
	c8.93-0.08,17.87-0.09,26.81,0c4.73,0.05,7.81,3.08,7.73,7.26c-0.07,4.03-3.09,6.88-7.67,7C255.83,48.29,251.31,48.2,246.78,48.2z"
      />
      <path
        style={{ fill: '#435C73' }}
        d="M246.73,118.75c-4.52,0-9.04,0.07-13.56-0.02c-4.58-0.09-7.53-2.93-7.52-7.03c0.01-4.05,3.08-7,7.55-7.02
	c9.04-0.05,18.08-0.05,27.12,0c4.5,0.02,7.61,2.88,7.69,6.9c0.08,4.2-2.96,7.09-7.72,7.17
	C255.78,118.81,251.25,118.75,246.73,118.75z"
      />
      <path
        style={{ fill: '#435C73' }}
        d="M246.55,189.45c-4.41,0-8.82,0.04-13.23-0.01c-4.48-0.05-7.6-2.92-7.67-6.92c-0.07-4.11,2.88-7.08,7.41-7.13
	c9.15-0.09,18.3-0.08,27.45,0c4.56,0.04,7.53,2.95,7.51,7.04c-0.02,4.02-3.13,6.96-7.58,7.01
	C255.81,189.5,251.18,189.45,246.55,189.45z"
      />
      <path
        style={{ fill: '#e12842' }}
        d="M139.27,301.52c-16.36-3.47-26.98-13.52-31.95-29.16c-6.47-20.33,3.91-42.47,23.46-50.98
	c2.19-0.95,2.86-2.01,2.85-4.33c-0.08-31.43-0.05-62.87-0.04-94.3c0-1.32,0.09-2.64,0.14-3.96c0.45-0.72,1.17-1.1,1.95-1.07
	c4.22,0.12,8.56-1.21,12.64,0.93c1.06,1.72,0.73,3.64,0.73,5.49c0.02,30.03,0.07,60.06-0.05,90.1c-0.01,3.61,0.92,5.66,4.34,7.45
	c25.84,13.55,31.48,47.09,11.58,68.41c-4.81,5.15-10.81,8.72-17.47,11.08C144.79,302.1,142.02,301.86,139.27,301.52z"
      />
      <path
        style={{ fill: '#dd213a' }}
        d="M139.27,301.52c13.37-0.93,23.16-7.89,30.03-18.85c9.35-14.91,8.95-30.27,0.03-45.23
	c-4.3-7.21-10.65-12.61-18.43-15.96c-2.08-0.9-2.84-1.79-2.84-4.03c0.07-32.77,0.07-65.55,0.08-98.32c4.62-1.51,9.24-1.5,13.85,0.01
	c0.01,28.97,0.02,57.95,0.03,86.92c0,1.32,0.07,2.64,0.1,3.96c0.73,1.31,0.97,2.76,0.74,4.18c-0.65,4.06,1.12,6.32,4.88,7.71
	c2.43,0.9,4.93,2.07,6.22,4.66c7.52,6.33,13.03,14.06,15.11,23.73c3.53,16.38-0.97,30.37-13.32,41.78
	c-0.64,0.59-1.26,1.22-1.88,1.83c-6.82,4.7-14.21,7.84-22.56,8.56C147.23,302.8,143.23,302.59,139.27,301.52z"
      />
      <path
        style={{ fill: '#EDECF2' }}
        d="M162,119.13c-4.62,0-9.23,0-13.85-0.01c-4.79-0.83-9.61-0.21-14.42-0.35c-0.05-17.4-0.18-34.8-0.1-52.19
	c0.03-6.81-0.7-13.65,0.49-20.42c1.5-8.53,8.14-13.17,16.63-11.79c0.43,0.07,0.88,0.04,1.32,0.06c7.18,3.11,10.13,8.53,10.04,16.36
	C161.88,73.58,162.01,96.36,162,119.13z"
      />
      <path
        style={{ fill: '#A4D2EB' }}
        d="M173.98,226.56c-2.42-1.46-4.69-3.41-7.31-4.25c-4.1-1.32-5.32-3.75-4.67-7.72c0.24-1.49,0.11-3.05,0.14-4.57
	c4.95,4.08,8.3,9.42,11.6,14.8C174.03,225.3,174.63,225.89,173.98,226.56z"
      />
    </SvgIcon>
  )
}
export default THIColoredIcon
